import React from 'react';
import poweredByIcon from './icons/powered-by-icon.png';

export const Footer = () => {
  return (
    <footer>
      <h5>©{(new Date).getFullYear()} Brandfolder, Inc.</h5>
      <a href='https://brandfolder.com' target='_blank' rel='noopener noreferrer'>
        <img src={ poweredByIcon } alt='Powered by Brandfolder logo'/>
      </a>
      <div className='footer-links'>
        <a className='link' href='https://brandfolder.com/agreement/#!texts/xpxac06k' target='_blank' rel='noopener noreferrer'>
          <h5>Privacy Policy</h5>
        </a>
        <a className='link' href='https://brandfolder.com/agreement/#!texts/14negh88' target='_blank' rel='noopener noreferrer'>
          <h5>Terms of Service</h5>
        </a>
        <a className='link'>
          <h5>Contact Us</h5>
        </a>
      </div>
    </footer>
  )
}
